export const ASSESSMENT = 'ASSESSMENT';
export const REVIEW = 'REVIEW';
export const IMPLEMENTATION = 'IMPLEMENTATION';
export const ANALYSIS = 'ANALYSIS';
